import React, { useState } from 'react';
import { Dialog, Button, Typography, ButtonGroup, Box } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { asyncFetch } from '../../helperFunctions';
import { resetPasswordAndroidBox, setSnackbar } from '../redux';

const buttonGroupStyle = { position: 'sticky', width: '100%', top: '0', zIndex: '100' };
const buttonStyle = { width: '100%' };
const boxStyle = { display: 'flex', flexDirection: 'column' };
const margin20px = { margin: '20px' };

export default () => {
  const { width } = useWindowDimensions();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const dialog = useSelector(state => state.tasks.resetPasswordAndroidBox);
  const smallerFontSize = width <= 500 ? '3.5vw' : '18px';

  return (
    dialog?.open && (
      <Dialog open={dialog.open} fullScreen>
        <div>
          <ButtonGroup style={buttonGroupStyle}>
            <Button
              disabled={loading}
              onClick={() => dispatch(resetPasswordAndroidBox({ open: false, houseHoldId: null }))}
              variant="contained"
              color="secondary"
              style={buttonStyle}
            >
              <Typography gutterBottom component="span" style={{ fontSize: smallerFontSize }}>
                Не
              </Typography>
            </Button>
            <Button
              disabled={loading}
              onClick={async () => {
                setLoading(true);

                const response = await asyncFetch(
                  `${process.env.REACT_APP_TECHNICIANS_API}/Tasks/ottclient-resetpassword`,
                  {
                    method: 'POST',
                    mode: 'cors',
                    referrerPolicy: 'strict-origin-when-cross-origin',
                    body: JSON.stringify({
                      houseHoldId: dialog.houseHoldId,
                    }),
                  },
                  {
                    'Content-Type': 'application/json',
                  },
                  undefined,
                  dispatch
                );
                setLoading(false);
                if (response.isSuccess) {
                  dispatch(resetPasswordAndroidBox({ open: false, houseHoldId: null }));
                  dispatch(
                    setSnackbar({
                      open: true,
                      message: 'Действието е извършено успешно.',
                    })
                  );
                } else {
                  dispatch(
                    setSnackbar({
                      open: true,
                      message: response.errorMessage,
                    })
                  );
                  dispatch(resetPasswordAndroidBox({ open: false, houseHoldId: null }));
                }
              }}
              variant="contained"
              color="secondary"
              style={buttonStyle}
            >
              <Typography gutterBottom component="span" style={{ fontSize: smallerFontSize }}>
                Да
              </Typography>
            </Button>
          </ButtonGroup>
          <Box style={boxStyle}>
            <Typography style={margin20px}>
              Сигурни ли сте, че искате да се върнете към стандартна парола по подразбиране за този
              потребител?
            </Typography>
          </Box>
        </div>
      </Dialog>
    )
  );
};
